/*
 * @Author: your name
 * @Date: 2021-05-28 20:18:01
 * @LastEditTime: 2021-07-06 10:40:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\store\getters.js
 */
// import {getStore } from '../utils/storage'
export default {
    get_userInfo : state => {
         return state.USERINFO;
    }
}